import { styled } from '@mui/material/styles';

/** Inline mark for a flagged fragment inside running text. */
export const TextHighlight = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.error.contrastText,
  padding: theme.spacing(0.375, 0.75),
  borderRadius: theme.shape.borderRadius,
  fontWeight: theme.typography.fontWeightBold,
  boxShadow: theme.customShadows.card,
  border: `1px solid ${theme.palette.error.dark}`,
}));
